import React from "react";

function UserPrompt() {
  return <span className="prompt userPrompt">{">>>"}</span>;
}

export default UserPrompt;
